import React, { useState } from "react";

import AffiliateCouponsForm from "components/AffiliateCouponsForm/AffiliateCouponsForm";
import { COUPON_EXPIRY_TYPES, COUPON_STATES,COUPON_TYPES } from 'coupon-common';

const AffiliateCustomCoupon = ({
    affiliateBusinesses,
    selectedBusinessId,
    dispatch,
    inputValue,
    onClose,
}) => {
    const [customCoupon] = useState({
        localId: `custom-${Date.now()}`, // unique localId
        title: "",
        description: "",
        price: "",
        expiry_type: COUPON_EXPIRY_TYPES.DATE,
        published_at: null,
        type: COUPON_TYPES.PERCENTAGE_OFF,
        expiration_date: null,
        expiration_quantity: null,
        image_url: [
            { image_url: "", sequence: 1 }
        ],
        link_url: "",
        state: COUPON_STATES.PUBLISHED,
        auto_accept: false,
        is_affiliate_or_flyer: true,
    });

    const handleRemove = () => {
        // call onClose to remove this component from view
        if (onClose) onClose();
    };

    return (
        <div style={{ marginTop: 20, marginBottom: 20 }}>
            <AffiliateCouponsForm
                coupon={customCoupon}
                index={0}
                affiliateBusinesses={affiliateBusinesses}
                selectedBusinessId={selectedBusinessId}
                dispatch={dispatch}
                handleRemove={handleRemove}
                inputValue={inputValue}
                customCoupon={true}
            />
        </div>
    );
};

export default AffiliateCustomCoupon;
